/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
export type employees_ProvisionLoginRequest = {
    role: employees_ProvisionLoginRequest.role;
};
export namespace employees_ProvisionLoginRequest {
    export enum role {
        ADMIN = 'admin',
        STAFF = 'staff',
    }
}

